

export const setOSCChannelState = (OSCChannelsStatus) => (
  {
    type:'SET_OSC_CHANNELS',
    OSCChannelsStatus,
  }
);